export const allPriceBooks = {
    BER: {
        data: [
            {
                "id": "09737288d0c970c908537053a72980ba",
                "product": {
                    "type": "FEE",
                    "ref": "OVERDUE_NOTICE_FEE"
                },
                "plans": [
                    {
                        "id": "5861e7785fef210e8ff4c7ce15dfb37d",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 10,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "0ac46f5d65a5d1ec29e6f3fabd2ba1a1",
                "product": {
                    "type": "INSURANCE",
                    "ref": "100000"
                },
                "location": "BER",
                "plans": [
                    {
                        "id": "9fdd445f2e09d31a218a11d0173b19f3",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 8.25,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "7b195470208e06d29489a29362e4934f",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 99,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "0c05e28bce18112cbee0b34ff64e8e38",
                "product": {
                    "type": "FEE",
                    "ref": "BOX_CLEARANCE_FEE"
                },
                "plans": [
                    {
                        "id": "76506a8c9d300b88e169fca4a6fe70a3",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 650,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "0dea244679f08602291015b44cce1dfd",
                "location": "BER",
                "product": {
                    "type": "BOX",
                    "ref": "STD"
                },
                "plans": [
                    {
                        "id": "a4a39a441a093adcf31710474723e6d2",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 24,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "BOX_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "b5ec48b32545877f169a3f348296e1cc",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 288,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": []
                    }
                ],
                "meta": {
                    "size": "STD",
                    "scale": {
                        "width": 235,
                        "height": 49,
                        "deep": 365
                    },
                    "volume": 3.7
                }
            },
            {
                "id": "296e4674aac1b28b027cc31d45e15677",
                "product": {
                    "type": "INSURANCE",
                    "ref": "1000000"
                },
                "location": "BER",
                "plans": [
                    {
                        "id": "77afbfb2a0c15b85803342ff032398fb",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 90.75,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "57752d4424527b09420054898a30e671",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 1089,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "29a86dba71404980e35cb91f4b9b6566",
                "product": {
                    "type": "INSURANCE",
                    "ref": "30000"
                },
                "location": "BER",
                "plans": [
                    {
                        "id": "33e427b636b0c537f00e3489e76703e7",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 1.83,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "232491c028804252dab4f608059c5d2b",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 22,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "2a31d06f1e9ae9c5857e4ad39934d820",
                "product": {
                    "type": "FEE",
                    "ref": "UNSCHEDULED_SAFE_OPENING_FEE"
                },
                "plans": [
                    {
                        "id": "59d4faae2f79da2aacb60fcc3903df60",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 650,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "54c8fbd75a210e6d119d3ca61c02923d",
                "location": "BER",
                "product": {
                    "type": "BOX",
                    "ref": "MAX"
                },
                "plans": [
                    {
                        "id": "576ab14bf0a897d8386b61cba5c2bd9b",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 54,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "BOX_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "ac4a4ce1f5de68d6f067b339b3b3a307",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 648,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": []
                    }
                ],
                "meta": {
                    "size": "MAX",
                    "scale": {
                        "width": 235,
                        "height": 186,
                        "deep": 365
                    },
                    "volume": 15.9
                }
            },
            {
                "id": "66cbc5fce34d131bdb317537b733fb43",
                "product": {
                    "type": "PARTNER",
                    "ref": "PARTNER"
                },
                "plans": [
                    {
                        "id": "885fa21da28f4e645ba2997598d6a92d",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 5,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "PARTNER_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "250e90c0f02d82b659320884fb797507",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 60,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "PARTNER_ACTIVATION_FEE"
                        ]
                    }
                ],
                "location": "BER"
            },
            {
                "id": "83d57fb37bd5afb47d7ffe90e34748d3",
                "product": {
                    "type": "FEE",
                    "ref": "BOX_ACTIVATION_FEE"
                },
                "plans": [
                    {
                        "id": "63976f61ec7f72f9d7dd82b48bb9cb7b",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 15,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "8ccbf27d6fbaa2273f98145531a3b1c1",
                "product": {
                    "type": "INSURANCE",
                    "ref": "500000"
                },
                "location": "BER",
                "plans": [
                    {
                        "id": "136fc9e318879b3a36fc9497cbcb86f9",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 44.92,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "4db8b7219627ba7ab28ab559460d4414",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 539,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "98ea3170a15d6b5e3200ee7273860976",
                "product": {
                    "type": "INSURANCE",
                    "ref": "250000"
                },
                "location": "BER",
                "plans": [
                    {
                        "id": "2fd296e346cb1225d75618e5c7cc2125",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 22,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "d22b62c97855fbd8ec665d4644f42e3f",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 264,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "a9860ecb034cf309f6fca857c49a8eab",
                "product": {
                    "type": "FEE",
                    "ref": "RESET_BIOMETRIC_FEE"
                },
                "plans": [
                    {
                        "id": "04350b4e1ae7f780e7951354439cc80f",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 25,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "bcac6d4f86fa781db3982e57cc28e9f3",
                "product": {
                    "type": "FEE",
                    "ref": "PARTNER_ACTIVATION_FEE"
                },
                "plans": [
                    {
                        "id": "63976f61ec7f72f9d7dd82b48bb9cb7b",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 15,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "ca94d8913071657f0fad1e7243fc6e88",
                "product": {
                    "type": "FEE",
                    "ref": "ONBOARDING_SERVICE_FEE"
                },
                "plans": [
                    {
                        "id": "1392b5b8e14aac9d5d60ff3cb2f8425a",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 75,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "df8fb5d31f2f76707c562b9fcf1e61de",
                "product": {
                    "type": "FEE",
                    "ref": "REPLACE_BOX_LOCK_FEE"
                },
                "plans": [
                    {
                        "id": "ad28a52bdf96bbd536a1dae38c0e5477",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 95,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "e61196541a50f1a71c21a6734a15917b",
                "product": {
                    "type": "INSURANCE",
                    "ref": "50000"
                },
                "location": "BER",
                "plans": [
                    {
                        "id": "1bb507c640e8e252494f3963cbd70eef",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 3.67,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "2a27146d900ef46b0f136a24ad7dd080",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 44,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "e991ba8878df39a1e8f69e3f9bd8d1bb",
                "product": {
                    "type": "FEE",
                    "ref": "REPLACE_CUSTOMER_CARD_FEE"
                },
                "plans": [
                    {
                        "id": "1f6c4324762abb96a160628f4c39e16a",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 50,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            },
            {
                "id": "e9c2a604d0133a653cb053f7b17524a6",
                "product": {
                    "type": "FEE",
                    "ref": "REPLACE_BOTH_BOX_LOCKS_FEE"
                },
                "plans": [
                    {
                        "id": "7106a2e10a43b7c6b8c45ee448a708a3",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 175,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "BER"
            }
        ]
    },
    STR: {
        data: [
            {
                "id": "1aaf94a31ac0014cafa914703213003b",
                "product": {
                    "type": "INSURANCE",
                    "ref": "30000"
                },
                "location": "STR",
                "plans": [
                    {
                        "id": "33e427b636b0c537f00e3489e76703e7",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 1.83,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "232491c028804252dab4f608059c5d2b",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 22,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "1e940da3a844fde29e6bdc6cab403652",
                "product": {
                    "type": "FEE",
                    "ref": "RESET_BIOMETRIC_FEE"
                },
                "plans": [
                    {
                        "id": "04350b4e1ae7f780e7951354439cc80f",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 25,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "211db6695dcf37e72f724014553e804f",
                "product": {
                    "type": "INSURANCE",
                    "ref": "100000"
                },
                "location": "STR",
                "plans": [
                    {
                        "id": "9fdd445f2e09d31a218a11d0173b19f3",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 8.25,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "7b195470208e06d29489a29362e4934f",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 99,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "30853236f3803ec6247bdf061ae303f4",
                "product": {
                    "type": "PARTNER",
                    "ref": "PARTNER"
                },
                "plans": [
                    {
                        "id": "885fa21da28f4e645ba2997598d6a92d",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 5,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "PARTNER_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "250e90c0f02d82b659320884fb797507",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 60,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "PARTNER_ACTIVATION_FEE"
                        ]
                    }
                ],
                "location": "STR"
            },
            {
                "id": "3268d3ddde4fafa45b6c6ccf77e54076",
                "product": {
                    "type": "FEE",
                    "ref": "REPLACE_BOX_LOCK_FEE"
                },
                "plans": [
                    {
                        "id": "ad28a52bdf96bbd536a1dae38c0e5477",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 95,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "40b08545386956bed4e0ad2ded54e018",
                "location": "STR",
                "product": {
                    "type": "BOX",
                    "ref": "SPL"
                },
                "plans": [
                    {
                        "id": "5993f3de5b62ebfbfcaf81efce03379d",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 34,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "BOX_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "3be6e2ec0df088076b8613fd12f124a2",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 408,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": []
                    }
                ],
                "meta": {
                    "size": "SPL",
                    "scale": {
                        "width": 235,
                        "height": 118,
                        "deep": 325
                    },
                    "volume": 0
                }
            },
            {
                "id": "436f48bf932c4d772cc8344b29bc8c04",
                "product": {
                    "type": "FEE",
                    "ref": "BOX_CLEARANCE_FEE"
                },
                "plans": [
                    {
                        "id": "76506a8c9d300b88e169fca4a6fe70a3",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 650,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "5c372bd48adb8a1337b4ccbaecefcf42",
                "product": {
                    "type": "FEE",
                    "ref": "REPLACE_BOTH_BOX_LOCKS_FEE"
                },
                "plans": [
                    {
                        "id": "7106a2e10a43b7c6b8c45ee448a708a3",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 175,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "61bfedbc36c4b702d1c988c51d61140c",
                "product": {
                    "type": "FEE",
                    "ref": "OVERDUE_NOTICE_FEE"
                },
                "plans": [
                    {
                        "id": "5861e7785fef210e8ff4c7ce15dfb37d",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 10,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "7ddd90e832ffc0d8de3fe7e3533fc31a",
                "product": {
                    "type": "FEE",
                    "ref": "BOX_ACTIVATION_FEE"
                },
                "plans": [
                    {
                        "id": "63976f61ec7f72f9d7dd82b48bb9cb7b",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 15,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "a4029f73fbfbcb179d239f3ebb2f6630",
                "product": {
                    "type": "FEE",
                    "ref": "REPLACE_CUSTOMER_CARD_FEE"
                },
                "plans": [
                    {
                        "id": "1f6c4324762abb96a160628f4c39e16a",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 50,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "ba639210d64104f02dbecd43255b2aad",
                "product": {
                    "type": "FEE",
                    "ref": "PARTNER_ACTIVATION_FEE"
                },
                "plans": [
                    {
                        "id": "63976f61ec7f72f9d7dd82b48bb9cb7b",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 15,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "c0b5ce4e29f0238cb4b846a2155a3e8c",
                "location": "STR",
                "product": {
                    "type": "BOX",
                    "ref": "MAX"
                },
                "plans": [
                    {
                        "id": "576ab14bf0a897d8386b61cba5c2bd9b",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 54,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "BOX_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "ac4a4ce1f5de68d6f067b339b3b3a307",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 648,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": []
                    }
                ],
                "meta": {
                    "size": "MAX",
                    "scale": {
                        "width": 235,
                        "height": 186,
                        "deep": 325
                    },
                    "volume": 0
                }
            },
            {
                "id": "c5ae05004633419adad1720ef72eecbc",
                "product": {
                    "type": "FEE",
                    "ref": "ONBOARDING_SERVICE_FEE"
                },
                "plans": [
                    {
                        "id": "1392b5b8e14aac9d5d60ff3cb2f8425a",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 75,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "dfc850251cb3f35ccda43ed85e4d243a",
                "product": {
                    "type": "INSURANCE",
                    "ref": "1000000"
                },
                "location": "STR",
                "plans": [
                    {
                        "id": "77afbfb2a0c15b85803342ff032398fb",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 90.75,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "57752d4424527b09420054898a30e671",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 1089,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "e08eff2fa6894fdcaa08b51c604b06ed",
                "product": {
                    "type": "FEE",
                    "ref": "UNSCHEDULED_SAFE_OPENING_FEE"
                },
                "plans": [
                    {
                        "id": "59d4faae2f79da2aacb60fcc3903df60",
                        "interval": {
                            "unit": "ONCE",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 650,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ],
                "location": "STR"
            },
            {
                "id": "e941ca6b03e6a3b7445f5d9962f6c5aa",
                "location": "STR",
                "product": {
                    "type": "BOX",
                    "ref": "STD"
                },
                "plans": [
                    {
                        "id": "a4a39a441a093adcf31710474723e6d2",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 24,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": [
                            "BOX_ACTIVATION_FEE"
                        ]
                    },
                    {
                        "id": "b5ec48b32545877f169a3f348296e1cc",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 288,
                            "vat": 0.19,
                            "currency": "EUR"
                        },
                        "requires": []
                    }
                ],
                "meta": {
                    "size": "STD",
                    "scale": {
                        "width": 235,
                        "height": 49,
                        "deep": 325
                    },
                    "volume": 0
                }
            },
            {
                "id": "f5b0a63565953a9b91006d3a230374a6",
                "product": {
                    "type": "INSURANCE",
                    "ref": "500000"
                },
                "location": "STR",
                "plans": [
                    {
                        "id": "136fc9e318879b3a36fc9497cbcb86f9",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 44.92,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "4db8b7219627ba7ab28ab559460d4414",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 539,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "f92e885cf3b0bb2777d9cfb68ea0ee92",
                "product": {
                    "type": "INSURANCE",
                    "ref": "250000"
                },
                "location": "STR",
                "plans": [
                    {
                        "id": "2fd296e346cb1225d75618e5c7cc2125",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 22,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "d22b62c97855fbd8ec665d4644f42e3f",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 264,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            },
            {
                "id": "fe8c6681e18e412e406a3fa291bc4b24",
                "product": {
                    "type": "INSURANCE",
                    "ref": "50000"
                },
                "location": "STR",
                "plans": [
                    {
                        "id": "1bb507c640e8e252494f3963cbd70eef",
                        "interval": {
                            "unit": "MONTHLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 3.67,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    },
                    {
                        "id": "2a27146d900ef46b0f136a24ad7dd080",
                        "interval": {
                            "unit": "YEARLY",
                            "cycles": 1
                        },
                        "price": {
                            "unit": 44,
                            "vat": 0.19,
                            "currency": "EUR"
                        }
                    }
                ]
            }
        ]
    }
}
